import React from "react";
import { Flex, Select } from "../../../resourses/digitallabs/one-x-ui";

const DynamicSelectYearpicker = ({
  field,
  fieldName,
  value,
  isMain,
  step,
  fieldRefs,
  currentDOB,
  normalizeYearValues,
  normalizeCurrentAndNextYear,
  normalizeSelectValue,
  updateValue,
  renderLabelWithPrefix,
  fieldIsRequired,
  validateSingleField,
  validateVisible,
  setErrors,
  setIsValid,
  onFormValidityChange,
  submitted,
  errors,
}) => {
  const isFutureDates = (rule) => {
    return rule.includes("future_year") ? true : false;
  };

  const items = isFutureDates(field.rules) ? normalizeCurrentAndNextYear() : normalizeYearValues(currentDOB);
  const current = value ?? field.default_answer ?? "";

  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <Select
        items={items}
        value={normalizeSelectValue(current)}
        closeOnSelect
        label={{
          label: renderLabelWithPrefix(isMain, field.question, step),
          optional: !fieldIsRequired(field),
        }}
        valuePlaceholder="Select year"
        onValueChange={(details) => {
          const selectedValue = details.value?.[0] ?? "";
          updateValue(fieldName, selectedValue);
        }}
        onBlur={() => {
          const single = validateSingleField(field);
          setErrors((prev) => ({ ...prev, ...single }));

          const validation = validateVisible();
          const valid = Object.keys(validation).length === 0;

          setIsValid(valid);
          if (typeof onFormValidityChange === "function") {
            onFormValidityChange(valid);
          }
        }}
        size="md"
        helperText={submitted && errors[fieldName] ? { message: errors[fieldName], status: "error" } : undefined}
      />
    </Flex>
  );
};

export default DynamicSelectYearpicker;
